import {
  STOTrendsCard,
  STOTrendsDeltasWrapper,
  STOTrendsExportButton,
  STOTrendsFlexResponsiveContainer,
  STOTrendsFlexRowContainer,
  STOTrendsGraphWrapper,
  STOTrendsStyledLeftHeader,
  STOTrendsStyledRightHeader,
} from 'modules/intelligentInsights/stoInsights/components/stoTrends/STOTrends.styles';
import { SegmentedControl } from 'ui/segmentedControl/SegmentedControl';
import { STOTrendsGraph } from 'modules/intelligentInsights/stoInsights/components/stoTrends/STOTrendsGraph';
import { MarginlessBody2 } from 'modules/intelligentInsights/stoInsights/components/common.styles';
import { STOTrendsDeltas } from 'modules/intelligentInsights/stoInsights/components/stoTrends/STOTrendsDeltas';
import {
  STO_TRENDS_LEFT_TITLE,
  STO_TRENDS_RIGHT_TITLE,
} from 'modules/intelligentInsights/stoInsights/constants';
import { Export16 } from 'ui/icons';
import { BUTTON_VARIANTS } from 'ui/button';
import { TrendTypeEnum } from 'modules/intelligentInsights/brandAffinityInsights/types';
import { useState } from 'react';
import { useSTOInsightsCoreContext } from 'modules/intelligentInsights/stoInsights/contexts/CoreContext';
import { STOTrendsSkeleton } from 'modules/intelligentInsights/stoInsights/components/stoTrends/STOTrendsSkeleton';

export const TrendGraphOptions = [
  {
    name: TrendTypeEnum.Percent,
    value: TrendTypeEnum.Percent,
  },
  {
    name: TrendTypeEnum.Count,
    value: TrendTypeEnum.Count,
  },
];

export const STO_TRENDS_BASE_CARD_TEST_ID = 'sto-insights-trends-base-card';
export const STO_TRENDS_CSV_EXPORT_BUTTON_TEST_ID = 'sto-insights-trends-export-button';

export const STOTrendsBase = () => {
  const { isReady } = useSTOInsightsCoreContext();
  const [graphOption, setGraphOption] = useState(TrendGraphOptions[0].value);

  const createCSVDataFile = () => {
    // TODO: Implement CSV export
  };

  return (
    <STOTrendsCard data-test={STO_TRENDS_BASE_CARD_TEST_ID}>
      <STOTrendsFlexRowContainer>
        <STOTrendsStyledLeftHeader>{STO_TRENDS_LEFT_TITLE}</STOTrendsStyledLeftHeader>
        <STOTrendsStyledRightHeader>
          <MarginlessBody2>{STO_TRENDS_RIGHT_TITLE}</MarginlessBody2>
          <SegmentedControl
            options={TrendGraphOptions}
            onSelect={(nextValue) => {
              setGraphOption(nextValue);
            }}
            value={graphOption}
          />
          <STOTrendsExportButton
            data-test={STO_TRENDS_CSV_EXPORT_BUTTON_TEST_ID}
            onClick={createCSVDataFile}
            variant={BUTTON_VARIANTS.SECONDARY}
          >
            <Export16 />
          </STOTrendsExportButton>
        </STOTrendsStyledRightHeader>
      </STOTrendsFlexRowContainer>
      <STOTrendsFlexResponsiveContainer>
        {!isReady ? (
          <STOTrendsSkeleton />
        ) : (
          <>
            <STOTrendsGraphWrapper>
              <STOTrendsGraph />
            </STOTrendsGraphWrapper>
            <STOTrendsDeltasWrapper>
              <STOTrendsDeltas />
            </STOTrendsDeltasWrapper>
          </>
        )}
      </STOTrendsFlexResponsiveContainer>
    </STOTrendsCard>
  );
};
